  <!-- 油卡充值 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "油卡充值", //导出时默认文件名
        apiName: "/admin/v3/tms/car/oil/recharge/getOliRechargeList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:oil_card_recharge:addOliRecharge",
        },
        {
          name: "修改",
          method: "modifyClick",
          permissVal: "admin:oil_card_recharge:udpateOliRecharge",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:oil_card_recharge:delOliRecharge",
        },
        {
          name: "审核过账",
          method: "approvePosting",
          permissVal: "admin:oil_card_recharge:examineOliRecharge",
        },
        {
          name: "反审核过账",
          method: "deApprovePosting",
          permissVal: "admin:oil_card_recharge:reExamineOliRecharge",
        },

        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "ExportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "卡号",
          field: "oilCardNumber",
          placeholder: "请输入",
        },

        {
          type: "input",
          label: "充值人",
          field: "rechargeUserName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "状态",
          field: "approveStatus",
          placeholder: "请选择",
          setLabel: "showName",
          setValue: "statusVal",
          selectOptions: [],
        },
      ],

      queryData: {
        approveStatus: null,
        endRechargeTime: null,
        oilCardNumber: null,
        rechargeUserName: null,
        startRechargeTime: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "充值时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      className: "", //  导出需要
      pageGroupName: "GascardEtc", //  页面标识
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 290,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:oil_card_recharge:udpateOliRecharge",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:oil_card_recharge:delOliRecharge",
            },
            {
              method: "approvePosting",
              methodName: "审核过账",
              permissVal: "admin:oil_card_recharge:reExamineOliRecharge",
            },
            {
              method: "deApprovePosting",
              methodName: "反审核过账",
              permissVal: "admin:oil_card_recharge:reExamineOliRecharge",
            },
          ],
        },
        {
          name: "充值时间",
          field: "rechargeTime",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "油卡号码",
          field: "oilCardNumber",
          sort: 4,
          isShow: true,
          isSort: true,
          isTotal: false,
        },
        {
          name: "卡类型",
          field: "isMainCardShow",
          sort: 5,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
        {
          name: "充值金额",
          field: "amount",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "充值人",
          field: "rechargeUserName",
          sort: 6,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
        {
          name: "需要核销",
          field: "isNeedWriteoffShow",
          sort: 1,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
        {
          name: "状态",
          field: "approveStatusShow",
          sort: 1,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
        {
          name: "	修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isSort: false,
          isTotal: false,
        },

        {
          name: "备注",
          field: "remarks",
          sort: 19,
          isShow: true,
          isSort: false,
          isTotal: false,
        },
      ],
      sortName: "油卡充值", //  排序名
      pageGroupName: "GascardEtc",
      //   车辆弹窗
      diaWidth: "60%",
      dialogTitle: "油卡充值",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "充值时间",
              itemType: "datetime",
              field: "rechargeTime",
              placeholder: "请选择",
            },
            {
              span: 8,
              title: "油卡号",
              itemType: "select",
              field: "oilCardNumber",
              setLabel: "numberLabel",
              setValue: "oilCardNumber",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "充值金额",
              itemType: "input",
              field: "amount",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "充值人",
              itemType: "input",
              field: "rechargeUserName",
              placeholder: "请输入",
            },
            // {
            //   span: 8,
            //   title: "需要核销",
            //   itemType: "select",
            //   field: "isNeedWriteoff",
            //   placeholder: "请选择",
            //   options: [
            //     {
            //       label: "是",
            //       val: 1,
            //     },
            //     {
            //       label: "否",
            //       val: 0,
            //     },
            //   ],
            // },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "remarks",
              placeholder: "请输入",
            },
          ],
        },
      ],
      formRules: {
        // isNeedWriteoff: [
        //   { required: true, message: "请选择", trigger: "change" },
        // ],
        amount: [{ required: true, message: "请输入", trigger: "blur" }],
        oilCardNumber: [
          { required: true, message: "请输入有效油卡号", trigger: "blur" },
        ],
        rechargeTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      baseModel: {},
      defaultBaseModel: {
        amount: null,
        isNeedWriteoff: null,
        oilCardNumber: null,
        rechargeTime: null,
        rechargeUserName: null,
        remarks: null,
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    this.GetOilCardDownList();
    // this.GetStatusValList();
  },
  watch: {},
  methods: {
    // 获取油卡充值列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startRechargeTime = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endRechargeTime = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.OliRechargeList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---油卡充值列表`);
        }
      });
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },

    // 获取油卡
    GetOilCardDownList() {
      this.$API.OilCardDownList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          for (let i in result) {
            let MainCard = result[i].isMainCard == 1 ? "（主）" : "（子）";
            result[i].numberLabel = result[i].oilCardNumber + MainCard;
          }
          this.diaFormConfig[0].formItem[1].options = result;
        }
      });
    },
    //  公共接口: 各种状态下拉列表接口=>审核状态
    GetStatusValList() {
      this.$TOOLS.getStatusValList("xxxxxxx").then((res) => {
        this.baseConfig[3].selectOptions = res;
      });
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 导出
    ExportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 新增
    addClick() {
      this.isShowDialog = true;
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.isShowDialog = true;
        this.baseModel = this.selectTableData[0];
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              rechargeIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.rechargeIds.push(val.rechargeId);
            });
            this.$API.delOliRecharge(delReq).then((r) => {
              if (r.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.rechargeIds.length > 2) {
                    delReq.rechargeIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.rechargeId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.rechargeId == delReq.rechargeIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 审核过账
    approvePosting(data, t) {
      if (data) this.selectTableData = [data];
      let msg = "审核";
      if (t) msg = t;
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要${msg}过账所选数据?`, "提示:")
          .then((res) => {
            let params = {
              rechargeIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.rechargeIds.push(val.rechargeId);
            });

            if (t) {
              // 翻审核接口
              this.$API.reExamineOliRecharge(params).then((r) => {
                if (r.data.status === "success") {
                  this.GetData();
                  this.$message.success(r.data.message);
                }
              });
            } else {
              // 审核接口
              this.$API.examineOliRecharge(params).then((e) => {
                if (e.data.status === "success") {
                  this.GetData();
                  this.$message.success(e.data.message);
                }
              });
            }
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 返审核过账
    deApprovePosting(data) {
      this.approvePosting(data, "禁用");
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          param.isNeedWriteoff = 1;
          if (this.baseModel.rechargeId)
            param.rechargeId = this.baseModel.rechargeId;
          if (param.rechargeId) {
            // 修改接口
            this.$API.udpateOliRecharge(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addOliRecharge(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
          this.isShowDialog = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
          <style scoped lang="less">
</style>
          